import { Select, Tag } from 'antd'
import { useEffect, useState } from 'react'
import { getMyStorageUsage } from '../../Actions/UserAction'
import apiClient from '../../Utils/apiClient'
import { hasCapability } from '../../Utils/planCapabilities'
import { planUpgradeMessage } from '../../Utils/planUpsell'

export default function TagPicker({ documentId, onChange }) {
  const [tags, setTags] = useState([])
  const [selected, setSelected] = useState([])
  const [allowed, setAllowed] = useState(false)
  const [planId, setPlanId] = useState('starter')

  useEffect(() => {
    getMyStorageUsage().then((usage) => {
      const canUse = hasCapability(usage?.capabilities, 'tags')
      setAllowed(canUse)
      setPlanId(usage?.planId || usage?.subscriptionPlanId || 'starter')

      if (!canUse) {
        setTags([])

        return
      }

      apiClient.get('tags').then((res) => setTags(res.data?.result || []))
    })
  }, [])

  useEffect(() => {
    if (!documentId || !allowed) {
      return
    }

    apiClient.get(`tags/document/${documentId}`).then((res) => {
      const ids = (res.data?.result || []).map((t) => t._id || t.id)
      setSelected(ids)
    })
  }, [documentId, allowed])

  const onSelect = (tagIds) => {
    setSelected(tagIds)

    if (documentId && allowed) {
      apiClient.put(`tags/document/${documentId}`, { tagIds }).then(() => onChange?.(tagIds))
    }
  }

  if (!allowed) {
    return (
      <p style={{ color: '#64748b', fontSize: 13, margin: 0 }}>
        {planUpgradeMessage('tags', planId)}
      </p>
    )
  }

  return (
    <div>
      <Select
        mode="multiple"
        style={{ width: '100%' }}
        placeholder="Tags"
        value={selected}
        onChange={onSelect}
        options={tags.map((t) => ({ label: t.name, value: t._id || t.id }))}
      />
      <div style={{ marginTop: 8 }}>
        {tags
          .filter((t) => selected.includes(t._id || t.id))
          .map((t) => (
            <Tag key={t._id || t.id} color={t.color}>
              {t.name}
            </Tag>
          ))}
      </div>
    </div>
  )
}
